<template>
  <div class="mt-[-50px] flex-1 bg-black4 pt-[50px] h1:mt-[-70px] h1:pt-[70px]">
    <transition name="fade2">
      <div v-if="enStories">
        <div class="m-auto px-4 lg:px-24">
          <div class="my-6 md:mt-12 md:flex lg:mt-24">
            <h1 class="mb-2 text-2xl text-white md:mr-[5%] md:text-4xl">Wabunka Story</h1>
            <p class="text-sm text-white md:text-sm">Interviews that touch on the background of the experience,<br class="hidden md:block" />and Stories that give a deeper insight into Japan.</p>
          </div>
          <div class="flex flex-wrap justify-between md:mb-16 md:mt-0 md:justify-start md:gap-x-2 xl:gap-x-3 e2:gap-x-4">
            <template v-for="(enStory, i) in enStories" :key="enStory.id">
              <OrganismsEnStoryCard :aria-label="`story-card-${i}`" :data-testid="`story-card-${i}`" :en-story="enStory" />
            </template>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script setup lang="ts">
import { useEnStories } from '@/composables/models/useEnStories';
import { useBuildUrl } from '@/composables/utils/useBuildUrl';

const route = useRoute();
const { enStories } = await useEnStories({ fetchAll: true }, { theme: 'Person' });
const { buildUrlWithEndSlash } = useBuildUrl();

const TITLE = "Wabunka | In-Depth Stories on the Keepers of Japan's Traditions";
const DESCRIPTION = "Compelling stories for a deeper insight into Wabunka's experiences and Japanese culture.";

useServerSeoMeta({
  title: TITLE,
  ogTitle: TITLE,
  description: DESCRIPTION,
  ogDescription: DESCRIPTION,
});

useHead({
  link: [{ rel: 'canonical', href: buildUrlWithEndSlash(route.path) }],
});
</script>
